import {Middleware, SWRHook} from 'swr';
import {useRef, useEffect, useCallback} from 'react';


/**
 * @description: 数据为空时不刷新数据
 */
export const laggy: Middleware = (useSWRNext: SWRHook) => (key, fetcher, config) => {
    const laggyDataRef = useRef<any>();
    const swr = useSWRNext(key, fetcher, config);
    // @ts-ignore
    const canRefresh = swr.data?.canRefresh;
    useEffect(() => {
        // 如果数据不是 undefined，更新 ref。
        if (canRefresh) {
            laggyDataRef.current = swr.data;
        }
    }, [swr.data]);

    // 暴露一个方法来清除延迟的数据（如果有）。
    const resetLaggy = useCallback(() => {
        laggyDataRef.current = undefined;
    }, []);

    // 如果当前数据是 undefined，则回退到之前的数据。
    const dataOrLaggyData = !canRefresh ? laggyDataRef.current : swr.data;

    // 是否显示之前的数据？
    const isLagging = !canRefresh && laggyDataRef.current?.success;

    // 同时将 `isLagging` 字段添加到 SWR 中。
    return {
        ...swr,
        data: dataOrLaggyData,
        isLagging,
        resetLaggy,
    };
};

